"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSideMenuStyles = exports.sideMenuVars = exports.sideMenuCommon = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var sideMenuCommon = exports.sideMenuCommon = _commonProps.defaultCommonProps;
var sideMenuVars = exports.sideMenuVars = (0, _initVars.default)({
  applied: sideMenuCommon
});
var styles = function styles(theme) {
  return {
    variables: sideMenuVars.styles,
    menu: {
      display: "flex",
      flexDirection: "column"
    },
    content: {
      paddingTop: theme.spacing.base * 2
    }
  };
};
var useSideMenuStyles = exports.useSideMenuStyles = (0, _createUseStyles.default)(styles, {
  name: "SideMenu"
});